// import all images from assets/images directory
import img04 from "../all-images/cars-img/Hummer limosine.png";
import img02 from "../all-images/cars-img/2021 Bentley Continental GT.png";
import img03 from "../all-images/cars-img/bmw M7.png";
import img01 from "../all-images/cars-img/Aston Martin.png";
import img05 from "../all-images/cars-img/8-Passenger-Cadillac-Deville-Limousine.png";
import img06 from "../all-images/cars-img/limo.png";
import img07 from "../all-images/cars-img/Mercedes Benz S-Class.png";
import img08 from "../all-images/cars-img/audi-R8.png";

const carData = [
  {
    id: 1,
    brand: "Aston Martin",
    rating: 112,
    carName: "Aston Martin DB11",
    imgUrl: img01,
    model: "Model 3",
    price: 50,
    speed: "208mph",
    gps: "GPS Navigation",
    seatType: "Leather seats",
    automatic: "Automatic",
    description: "The Aston Martin DB11 is a grand tourer manufactured by British luxury car manufacturer Aston Martin since 2016. It is the successor to the DB9 and is available as a coupe and a convertible. The car features a 5.2-litre twin-turbocharged V12 engine, producing 600 horsepower and 516 lb-ft of torque. The DB11 is known for its luxurious interior and comfortable ride, as well as its impressive performance capabilities. If you're looking for a high-end, stylish grand tourer, the Aston Martin DB11 is an excellent choice.",
  },

  {
    id: 2,
    brand: "Bentley",
    rating: 102,
    carName: "Bentley Continental GT",
    imgUrl: img02,
    model: "Model-2022",
    price: 50,
    speed: "207mph",
    gps: "GPS Navigation",
    seatType: "Leather seats",
    automatic: "Automatic",
    description:
      " The 2021 Bentley Continental GT is a luxury grand tourer that combines performance, style, and comfort. Under the hood, it features a 6.0-liter W12 engine that produces 626 horsepower and 664 lb-ft of torque, allowing it to go from 0 to 60 mph in just 3.6 seconds. The car also has a top speed of 207 mph. The interior of the Continental GT is luxurious and spacious, with leather seats and a high-tech infotainment system. It also has a number of driver assistance features, such as adaptive cruise control and lane departure warning. If you're looking for a powerful and luxurious grand tourer, the 2021 Bentley Continental GT is definitely worth considering.",
  },

  {
    id: 3,
    brand: "BMW",
    rating: 132,
    carName: "M760i xDrive",
    imgUrl: img03,
    model: "Model-2021",
    price: 65,
    speed: "190mph",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " The 2021 BMW M760i xDrive is a luxury sedan that combines the elegance and comfort of the BMW 7 Series with the performance and excitement of an M car. It features a 6.6-liter V12 engine that produces 601 horsepower and 627 lb-ft of torque, allowing it to go from 0 to 60 mph in just 3.6 seconds. The car also has a top speed of 190 mph. The interior is spacious and luxurious, with leather seats and a high-tech infotainment system. It also has a number of driver assistance features, such as lane departure warning and forward collision warning. If you're looking for a luxurious and powerful sedan, the 2021 BMW M760i xDrive is an excellent choice.",
  },

  {
    id: 4,
    brand: "Hummer",
    rating: 102,
    carName: "H2 Limousine",
    imgUrl: img04,
    model: "Model-2022",
    price: 70,
    speed: "80mph",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " The Hummer H2 Limousine is a luxurious and spacious limousine that can accommodate up to 18 passengers. It features a powerful V8 engine and a smooth automatic transmission, ensuring a comfortable ride for all passengers. The interior is equipped with a range of amenities, including leather seats, a bar, a sound system, and a TV. The limousine is also equipped with GPS navigation, making it easy to get to your destination. If you're looking for a stylish and comfortable way to travel with a large group of people, the Hummer H2 Limousine is an excellent choice.",
  },

  {
    id: 5,
    brand: "Cadillac",
    rating: 94,
    carName: "Deville Limousine",
    imgUrl: img05,
    model: "Model-2021",
    price: 45,
    speed: "120mph",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " The Cadillac Deville Limousine is a stylish and spacious limousine that can accommodate up to 8 passengers. It features a powerful V8 engine and a smooth automatic transmission, ensuring a comfortable ride for all passengers. The interior is equipped with leather seats, a sound system, and a TV. The limousine is also equipped with GPS navigation, making it easy to get to your destination. If you're looking for a luxurious and comfortable way to travel with a small group of people, the Cadillac Deville Limousine is an excellent choice.",
  },

  {
    id: 6,
    brand: "Aston Martin",
    rating: 119,
    carName: "DB11 Limousine",
    imgUrl: img06,
    model: "Model-2021",
    price: 85,
    speed: "180mph",
    gps: "GPS Navigation",
    seatType: "Leather seats",
    automatic: "Automatic",
    description:
      " The Aston Martin DB11 Limousine is a custom-built limousine based on the iconic DB11 sports car. It has been extended to accommodate up to 8 passengers and features a luxurious and spacious interior with leather seats, a sound system, and a TV. The car has been equipped with a powerful V12 engine that produces 600 horsepower, allowing it to reach speeds of up to 180 mph. The limousine also comes with GPS navigation, making it easy to get to your destination. If you're looking for a unique and luxurious way to travel with a small group of people, the Aston Martin DB11 Limousine is an excellent choice.",
  },

  {
    id: 7,
    brand: "Mercedes Benz",
    rating: 82,
    carName: "S-Class",
    imgUrl: img07,
    model: "Model S450",
    price: 50,
    speed: "180mph",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " The Mercedes Benz S-Class is a luxurious and spacious sedan that is perfect for long journeys. It features advanced technology, comfortable seating, and a smooth ride. The S-Class is equipped with a powerful engine that delivers impressive performance while maintaining fuel efficiency. The interior is designed with high-quality materials and the latest technology to provide a comfortable and convenient driving experience. With its sleek and elegant design, the S-Class is sure to turn heads on the road.",
  },

  {
    id: 8,
    brand: "Audi",
    rating: 52,
    carName: "R8",
    imgUrl: img08,
    model: "Model 3",
    price: 50,
    speed: "200mph",
    gps: "GPS Navigation",
    seatType: "Sports seats",
    automatic: "Automatic",
    description:
      " The Audi R8 is a high-performance sports car that delivers an exhilarating driving experience. Its powerful V10 engine and advanced transmission system provide exceptional acceleration and top speed. The R8 is also equipped with a range of advanced features, including GPS navigation and sports seats with Nappa leather upholstery. Its sleek and aerodynamic design is sure to turn heads wherever you go. With its superior handling and precision engineering, the Audi R8 is a true driver's car.",
  },
];

export default carData;
